import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/pages/newHome/ui/avatar";
import { Card, CardContent } from "@/pages/newHome/ui/card";
// import avatarRick from "@/assets/newHome/mask-group-7.png";
import avatarRick from "@/assets/newHome/rick.png";
import logoRick from "@/assets/newHome/image-18139.png";
// import avatarMike from "@/assets/newHome/mask-group-8.png";
import avatarMike from "@/assets/newHome/mike.png";
import logoMike from "@/assets/newHome/screenshot-2025-04-07-at-1-36-15-pm-1.png";
// import avatarRafael from "@/assets/newHome/mask-group-9.png";
import avatarRafael from "@/assets/newHome/rafael.png";
import logoRafael from "@/assets/newHome/screenshot-2025-04-07-at-1-39-12-pm-1.png";
// import avatarSunny from "@/assets/newHome/mask-group-10.png";
import avatarSunny from "@/assets/newHome/sunny.png";
import logoSunny from "@/assets/newHome/image-18140.png";
import videoBackground1 from "@/assets/newHome/01-1.png";
import videoBackground2 from "@/assets/newHome/img-2.png";
import playButton from "@/assets/newHome/image-18029.png";
import img3 from "@/assets/newHome/img-3.png";
import { useState } from "react";
import TypeWriterEffect from "@/components/animations/typewriter-effect";

const testimonialData = [
  {
    type: "stat",
    stat: "75%",
    description: "of the sales process handled by BuildMapper",
  },
  {
    type: "quote",
    name: "Rick Krishnan",
    position: "Sales Associate - Coast Appliances Vancouver",
    avatar: avatarRick,
    quote:
      "I would roughly estimate that more than 70% of the sales I've closed have been brought in using the information from the BuildMapper app. This app saves time and the information is at your fingertips. I would definitely encourage other sales professionals to use the BuildMapper app.",
    logo: logoRick,
  },
  {
    type: "video",
  name: "Rafael Tecson",
  position: "Sales-Klassen Building Supply",
  background: videoBackground1,
  playButton: playButton,
  videoUrl: "https://bmp-dummy-assets.s3.us-east-2.amazonaws.com/Testimonial_2.mp4", // Example URL
  },
  {
    type: "quote",
    name: "Mike Mikho",
    position: "Sales Manager - Patterson Whittaker Architec..",
    avatar: avatarMike,
    quote:
      "The BuildMapper service has helped me improve my sales process. I use the map to plan routes when meeting builders for potential sales. It is very useful to have all the information on builders available when needed.",
    logo: logoMike,
  },
  {
    type: "video",
    name: "Rob Poystila",
    position: "Sales Manager-Crown Building Supplies",
    background: videoBackground2,
    playButton: playButton,
    videoUrl: "https://bmp-dummy-assets.s3.us-east-2.amazonaws.com/Testimonial_1.mp4",
  },
  {
    type: "quote",
    name: "Rafael Tecson",
    position: "Sales – Klassen Building Supplies Ltd",
    avatar: avatarRafael,
    quote:
      "I can plan my day to day or week, the maps where construction site is nice visiting sites. I can set my route with lesser downtime ,lesser fuel consumption and seeing more clients.",
    logo: logoRafael,
  },
  {
    type: "stat-dark",
    stat: "12X",
    description: "Increase in lead flow for your team",
    background: img3,
  },
  {
    type: "quote",
    name: "Sunny Aujla",
    position: "President – Fibretech Distributors",
    avatar: avatarSunny,
    quote:
      "BuildMapper has to be one of the best tools for our business. We have been using it for over a year and the results have been great. The team has been amazing to deal with. Highly recommend for any business looking to increase sales and market share.",
    logo: logoSunny,
  },
  {
    type: "stat",
    stat: "300+",
    description: "Hours saved per year per sales rep",
  },
];

export const TestimonialsByAnima = (): JSX.Element => {
  const [playingVideoIndex, setPlayingVideoIndex] = useState<number | null>(null);
  return (
    <section className="w-full bg-white py-10 md:py-20 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 max-w-2xl mx-auto">
          {/* <h2 className="text-3xl md:text-4xl font-semibold text-charcoal mb-3">
            What our customers say
          </h2> */}
          <TypeWriterEffect text="What our customers say " />
          <p className="text-lg text-lightGray pt-1">
            Hear from our satisfied customers and clients.
          </p>
        </div>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:justify-center">
          {testimonialData.map((testimonial, index) => {
            const isLast = index === testimonialData.length - 1;
            const isOdd = testimonialData.length % 2 !== 0;

            const Wrapper = ({ children }: { children: React.ReactNode }) => {
              if (isLast && isOdd) {
                return (
                  <div className="md:col-span-2 lg:col-span-1 md:flex md:justify-center">
                    {children}
                  </div>
                );
              }
              return <>{children}</>;
            };

            return (
              <Wrapper key={index}>
                <Card className="h-[340px] rounded-lg border border-gray-200 overflow-hidden w-full max-w-md">
                  <CardContent className="h-full p-0">
                    {testimonial.type === "stat" && (
                      <div className="h-full flex flex-col items-center justify-center p-6">
                        <span className="text-6xl md:text-7xl font-bold text-primary">
                          {testimonial.stat}
                        </span>
                        <p className="text-xl md:text-2xl font-medium text-primary mt-2 text-center">
                          {testimonial.description}
                        </p>
                      </div>
                    )}

                    {testimonial.type === "stat-dark" && (
                      <div
                        className="h-full flex flex-col items-center justify-center p-6 bg-charcoal"
                        style={{
                          backgroundImage: `url(${testimonial.background})`,
                          backgroundSize: "cover",
                        }}
                      >
                        <span className="text-6xl md:text-7xl font-bold text-primary">
                          {testimonial.stat}
                        </span>
                        <p className="text-xl md:text-2xl font-medium text-white mt-2 text-center">
                          {testimonial.description}
                        </p>
                      </div>
                    )}

                    {testimonial.type === "quote" && (
                      <div className="h-full flex flex-col p-6">
                        <div className="flex items-center gap-4 mb-4">
                          <Avatar className="w-12 h-12">
                            <AvatarImage
                              src={testimonial.avatar}
                              alt={testimonial.name}
                            />
                            <AvatarFallback>
                              {testimonial.name?.charAt(0)}
                            </AvatarFallback>
                          </Avatar>
                          <div className="text-start">
                            <h3 className="font-semibold text-charcoal">
                              {testimonial.name}
                            </h3>
                            <p className="text-sm text-lightGray">
                              {testimonial.position}
                            </p>
                          </div>
                        </div>
                        <p className="text-gray-700 text-start mb-4 flex-grow">
                          "{testimonial.quote}"
                        </p>
                        {testimonial.logo && (
                          <img
                            src={testimonial.logo}
                            alt="Company logo"
                            className="h-10 object-contain mr-auto"
                          />
                        )}
                      </div>
                    )}

{testimonial.type === "video" && (
  <div
    className="h-full relative bg-cover bg-center"
    style={{
      backgroundImage: `url(${testimonial.background})`,
    }}
  >
    {playingVideoIndex === index ? (
      <video
        className="w-full h-full object-cover rounded"
        controls
        autoPlay
      >
        <source src={testimonial.videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    ) : (
      <div
        className="absolute inset-0 flex items-center justify-center cursor-pointer"
        onClick={() => setPlayingVideoIndex(index)}
      >
        <img
          src={testimonial.playButton}
          alt="Play"
          className="w-12 h-12"
        />
      </div>
    )}

    {/* Gradient + Info */}
    <div
      className={`${
        playingVideoIndex === index ? "static" : "absolute bottom-0 left-0 right-0"
      } h-32 bg-gradient-to-t from-black to-transparent`}
    >
      <div
        className={`${
          playingVideoIndex === index ? "static" : "absolute bottom-4 left-4"
        }`}
      >
        <h3 className="font-semibold text-white text-left">
          {testimonial.name}
        </h3>
        <p className="text-xs text-white">{testimonial.position}</p>
      </div>
    </div>
  </div>
)}


                  </CardContent>
                </Card>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};
